import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StatusComponent } from './status.component';
import { AddStatusComponent } from './add-status/add-status.component';
import { EditStatusComponent } from './edit-status/edit-status.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MaterialModule } from 'src/app/material.module';



@NgModule({
    declarations: [
        StatusComponent,
        AddStatusComponent,
        EditStatusComponent
    ],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        MaterialModule,
    ],
    exports: [StatusComponent]
})
export class StatusModule { }
